import { createSelector } from "reselect"
import { find } from "lodash"
import { CATEGORIES, CONCENTRATION_FACTORS } from "helpers/analyzeConstants"
import { getBetaColumnsAndTooltips } from "helpers/tables"
import { getSelectedModelName } from "modules/analyze-composite-security/selectors"
import { getFactorCategoryId } from "."

export const getSelected = createSelector(
  [getFactorCategoryId],
  (factorCategoryId) => {
    if (find(CATEGORIES, cat => cat.id === factorCategoryId)) {
      return factorCategoryId
    }

    return CATEGORIES[0].id
  },
)

export const getFactorCategoryName = createSelector(
  [getFactorCategoryId],
  (factorCategoryId) => {
    const category = find(CATEGORIES, cat => cat.id === factorCategoryId)
    if (category) {
      return category.label
    }

    return CATEGORIES[0].label
  },
)

const getBetaFactors = createSelector(
  [getSelectedModelName],
  getBetaColumnsAndTooltips,
)

export const getFactors = createSelector(
  [getFactorCategoryId, getBetaFactors],
  (factorCategoryId, betaFactors) => factorCategoryId === "beta" ? betaFactors : CONCENTRATION_FACTORS,
)
